export const GET_REQUISITION_DROP_DOWN = 'GET_REQUISITION_DROP_DOWN';
export const SET_REQUISITION_DROP_DOWN = 'SET_REQUISITION_DROP_DOWN';